app.controller('statsIndexCtrl', [
    '$scope', '$rootScope', '$http', 'mdContentService', '$locale', '$filter', function ($scope, $rootScope, $http, mdContentService, $locale, $filter) {
    	var vm = this;

        $locale.NUMBER_FORMATS.GROUP_SEP = '.';
        $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";

    	vm.rides = [];
    	vm.loaded = false;

        vm.chosenWeek = null;
        vm.chosenSchoolCategory = null;

        $scope.$watch('vm.chosenWeek', function() {
            if (vm.loaded) {
                vm.fetchData();
            }
        });

        $scope.$watch('vm.chosenSchoolCategory', function() {
            if (vm.loaded) {
                vm.fetchData();
            }
        });

        vm.fetchData = function() {
            var url = '/api/analytics/stats';
            if (vm.chosenWeek != null && vm.chosenSchoolCategory != null) {
                url += "?week=" + vm.chosenWeek + '&schoolCategory=' + vm.chosenSchoolCategory;
            }
            $http.post(url).then(function(response) {
                vm.stats = response.data;
                
                if (vm.chosenWeek == null) {
                    vm.chosenWeek = vm.stats.weeks[0].value;
                }
                if (vm.chosenSchoolCategory == null) {
                    vm.chosenSchoolCategory = vm.stats.schoolCategories[0].value;
                }
                
                vm.loaded = true;

                mdContentService.triggerSyntheticScrollEvent();

                // XXX: reload graphs

                vm.exerciseComplete = vm.makeChart(vm.stats.completedExercises);
                vm.teacherMsg = vm.makeChart(vm.stats.teacherMessages);
                vm.popularExercises = vm.makeExerciseChart(vm.stats.popularExercises);
                vm.exerciseTime = vm.makeExerciseTimeChart(vm.stats.averageTimeSpentPerExercise);

                var exercises = [];
                for (var i = 0; i < vm.stats.exercises.length; i++) {
                    var exerciseStats = vm.stats.exercises[i];
                    var questions = [];

                    console.dir(exerciseStats);

                    for (var j = 0; j < exerciseStats.questionStats.length; j++) {
                        var questionStats = exerciseStats.questionStats[j];
                        questions.push({
                            numberOfTriesChart: vm.makeNumberOfTriesChart(questionStats.numTriesGroups),
                            stats: questionStats,
                        });
                    }

                    exercises.push({
                        completionTimeGroupsChart: vm.makeCompletionTimeChart(exerciseStats.completionTimeGroups),
                        stats: exerciseStats,
                        questions: questions
                    });
                }

                vm.exerciseStats = exercises;
            });
        }

        vm.fetchData();

        vm.makeChart = function(statsData) {
            var chart = {};

            chart.labels = statsData.labels;
            chart.data = statsData.data;
            //chart.series = ["Antal gennemførte opgaver"];
            chart.datasetOverride = [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }];
            chart.options = {
                scales: {
                  yAxes: [
                    {
                      id: 'y-axis-1',
                      type: 'linear',
                      display: true,
                      position: 'left'
                    },
                    {
                      id: 'y-axis-2',
                      type: 'linear',
                      display: true,
                      position: 'right'
                    }
                  ]
                }
            };

            return chart;
        }

        vm.makeExerciseChart = function(statsData) {
            var chart = {};
            chart.labels = statsData.labels;
            chart.data = statsData.data;
            chart.series = ["Populare opgaver"];
            chart.datasetOverride = [];
            chart.options = {};
            return chart;
        }

        vm.makeExerciseTimeChart = function(statsData) {
            var chart = {};

            chart.labels = statsData.labels;
            chart.data = statsData.data;

            chart.series = ["Tidsforbrug for opgaver (gennemsnit i minutter)"];
            chart.datasetOverride = [];
            chart.options = {
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';

                            if (label) {
                                label += ': ';
                            }
                            label += $filter('number')(tooltipItem.xLabel, 2)
                            return label;
                        }
                   }
               }
           };

            return chart;
        }

        vm.makeCompletionTimeChart = function(completionTimeGroups) {
            var chart = {};

            chart.labels = ["0-15 min.", "15-30 min.", "30 min. eller mere"]
            chart.data = [completionTimeGroups.num0to15, completionTimeGroups.num15to30, completionTimeGroups.num30orGreater];

            chart.series = ["Antal forsøg før opgaven er løst"];
            chart.datasetOverride = [];
            chart.options = {
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
            };

            return chart;
        }

        vm.makeNumberOfTriesChart = function(numberOfTriesGroups) {
            var chart = {};

            chart.labels = ["Første forsøg", "Andet forsøg", "Tredje forsøg", "Fjerde forsøg"]
            chart.data = [numberOfTriesGroups.firstTry, numberOfTriesGroups.secondTry, numberOfTriesGroups.thirdTry, numberOfTriesGroups.fourthTry];

            chart.series = ["Antal forsøg før opgaven er løst"];
            chart.datasetOverride = [];
            chart.options = {};

            return chart;
        }
    }
]);